export enum PageKey {
  HOME = 'home',
  LOGIN = 'login',
  USERS = 'users',
  JOB_POSITIONS = 'job_positions',
  TEAMS = 'teams',
  COLLABORATORS = 'collaborators',
  WEEKLY_ALLOCATIONS = 'weekly_allocations',
  PROJECTS = 'projects',
  REPORTS = 'reports',
  REPORTS_PROJECTS = 'reports_projects',
  REPORTS_ALLOCATIONS = 'reports_allocations',
  COST_CENTERS = 'cost_centers',
  PLAYGROUND = 'playground'
}
